// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"goalsCard_mulitpleDropdown__3TXeI","loaderWrapper":"goalsCard_loaderWrapper__2WwWs"};